const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class BeautyRecommendationsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.2,
              spacing: 15,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.2,
              spacing: 15,
            },
          },
          '(min-width: 1200px)': {
            slides: {
              perView: 4.2,
              spacing: 15,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('beauty-recommendations-carousel')) {
  customElements.define(
    'beauty-recommendations-carousel',
    BeautyRecommendationsCarousel,
  )
}
